import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { wsGetAll } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import {
  Add,
  Close,
  Edit,
  Smartphone,
  DesktopWindows,
  AssignmentIndRounded
} from '@material-ui/icons';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import CardIcon from 'components/Card/CardIcon';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cod.', accessor: 'code' },
  { Header: 'Rol', accessor: 'role' },
  { Header: 'Tipo', accessor: 'type', excelEnabled: false },
  { Header: 'Creado', accessor: 'created' },
  { Header: 'Modificado', accessor: 'updated' },
  { Header: '', accessor: 'action', excelEnabled: false }
];

const useStyles = makeStyles(styles);

export default WithApp(function Roles(props) {
  const classes = useStyles();

  const [listRoles, setListRoles] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function getRoles() {
    setDataLoading(true);
    let response = await wsGetAll('oauth/roles');
    setDataLoading(false);
    if (response.success) {
      setListRoles(response.data);
    }
  }

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <AllowedGuard
          permission={ConstantPermissions.OAUTH_ROLES_STORE}
          component={
            <CardIcon color="primary">
              <AssignmentIndRounded style={{ color: 'white' }} />
            </CardIcon>
          }
        >
          <Link to="0">
            <CardIcon color="success" pointer="true">
              <Add style={{ color: 'white' }} />
            </CardIcon>
          </Link>
        </AllowedGuard>
        <h4 className={classes.cardIconTitle}>Listado de Roles {dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          indexRow={[0, 1, 3, 4, 5, 6]}
          widthRow={[130, 80, 90, 220, 220, 0]}
          indexColumn={[1, 3, 6]}
          alignColumn={['center', 'center', 'right']}
          defaultWidth={1000}
          columns={columns}
          data={listRoles.map((item, i) => ({
            num: (
              <div className="actions-right">
                {i + 1}
                <AllowedGuard permission={ConstantPermissions.OAUTH_ROLES_UPDATE}>
                  <Link to={`${item.id}`}>
                    <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                      <Edit />
                    </Button>
                  </Link>
                </AllowedGuard>
                <AllowedGuard permission={ConstantPermissions.OAUTH_ROLES_DELETED}>
                  <Button justIcon round simple color={props.themeContext.buttonColorDanger}>
                    <Close />
                  </Button>
                </AllowedGuard>
              </div>
            ),
            code: item.type,
            role: item.name,
            type: item.guard_name == 'web' ? <DesktopWindows /> : <Smartphone />,
            created: item.created_at,
            updated: item.updated_at,
            action: ''
          }))}
        />
      </CardBody>
    </Card>
  );
});
